dateWithDesiredMonth